import React from 'react';

import S from './Clock.module.css';

export const ClockImg = () => (
  <div className={S.root}>
    <div className={S.grayBlick}></div>
    <div className={S.centerDot}></div>
    <div className={S.minute}></div>
    <div className={S.second}></div>
    <div className={S.hour}></div>
    <ul>
      <li>1</li>
      <li>2</li>
      <li>3</li>
      <li>4</li>
      <li>5</li>
      <li>6</li>
      <li>7</li>
      <li>8</li>
      <li>9</li>
      <li>10</li>
      <li>11</li>
      <li>12</li>
    </ul>
  </div>
);
